module.exports = "<h2 id=\"presse\">PRESSE</h2>\n<p>Bei Presse-Anfragen wenden Sie sich bitte an <u><a href=\"mailto:mail@restaurant-richard.de\">mail@restaurant-richard.de</a></u></p>\n";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/press_de.md
// module id = 0XrP
// module chunks = 0